import type { FC, MouseEvent, ReactNode } from 'react'

import type { WhiteLabel } from '@skytech/types'

import './styles.scss'

type SelectableCardSize = 'regular'
type SelectableCardColor = 'green' | 'yellow' | 'blue'

export const SelectableCard: FC<{
  children?: ReactNode
  className?: String
  isSelected?: boolean
  disabled?: boolean
  type?: 'submit'
  colorMode?: SelectableCardColor
  size?: SelectableCardSize
  marginBottom?: number
  marginRight?: number
  marginTop?: number
  marginLeft?: number
  noMargin?: boolean
  noPadding?: boolean
  margin?: number
  padding?: number
  hasBoxShadow?: boolean
  bordered?: boolean
  textLeft?: boolean
  rounded?: boolean
  minHeight?: number
  flex?: boolean
  onClick?: (event: MouseEvent<HTMLElement>) => void
}> = ({
  className = '',
  children,
  size = 'regular',
  colorMode,
  isSelected,
  margin,
  marginBottom = 0,
  marginRight = 0,
  marginTop = 0,
  marginLeft = 0,
  padding,
  disabled,
  noMargin,
  noPadding,
  hasBoxShadow,
  bordered,
  textLeft,
  rounded,
  flex,
  minHeight,
  type = 'button' as const,
  ...restOfProps
}) => {
  // todo: replace with the org from url when ready
  const whiteLabel = localStorage.getItem('org') as WhiteLabel

  const style: Record<string, number> = {
    marginBottom,
    marginRight,
    marginTop,
    marginLeft,
  }

  if (noPadding) style.padding = 0
  if (noMargin) style.margin = 0
  if (padding) style.padding = padding
  if (margin) style.margin = margin
  if (minHeight) style.minHeight = minHeight

  return (
    <button
      className={`ui-selectable-card ${size} ${size} ${colorMode} ${className} ${whiteLabel} ${
        hasBoxShadow ? 'box-shadow' : ''
      } ${isSelected ? 'is-selected' : ''} ${bordered ? 'bordered' : ''} ${
        textLeft ? 'text-left' : ''
      } ${rounded ? 'rounded' : ''} ${flex ? 'flex' : ''} ${disabled ? 'disabled' : ''} `}
      type={type}
      style={style}
      disabled={disabled}
      {...restOfProps}
    >
      {children}
    </button>
  )
}
